/**
 * How a link names a reply. Kept apart from the thread's code so the frame, which is on
 * every page, can read a link without loading the sheet's words.
 */

/** The id the page and a link use for a reply: the target of `#r-<id>`. */
export const replyAnchor = (replyId: string) => `r-${replyId}`;

/** The reply a `#r-<id>` hash names, if it names one. */
export function replyFromHash(hash: string): string | null {
  const m = /^#r-([0-9a-f-]{8,})$/i.exec(hash);
  return m?.[1] ?? null;
}

/** A link to `#djinn` opens the sheet on the thread's end, from a page that is not the sheet's. */
export const DJINN_OPEN_HASH = "djinn";
